/* eslint-disable */
import { useCallback, useState, useEffect, useRef } from 'react'
import useAxiosPrivate from '../../hooks/useAxiosPrivate'
import UserProfile from '../../components/UserProfile'
import MainTitle from '../../components/MainTitle'
import { Link, useParams } from 'react-router-dom'
import useAuth from '../../hooks/useAuth'
import { faTrash,
  faUpload,
  faFile,
  faTrashCan,
  faEye,
  faCircleCheck,
  faFileContract, faShieldHalved, faIdCard, faCertificate, faUserShield, faPenToSquare, faXmarkCircle
 } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import UserNav from '../../components/UserNav'
import Modal from '../../components/Modal'
import { Switch } from '@headlessui/react'
import { Tooltip } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'


const DOCS = [
  { key: "bacp", label: "BACP membership", requiresEndDate: true },
  { key: "contract", label: "Contract", requiresEndDate: false },
  { key: "dpa", label: "DPA", requiresEndDate: false },
  { key: "dbs", label: "DBS check", requiresEndDate: false },
  { key: "ico", label: "ICO certificate", requiresEndDate: true },
  { key: "ppi", label: "Private practice insurance certificate", requiresEndDate: true },
]

const ICONS = {
  bacp: faIdCard,                // BACP Membership
  contract: faFileContract,      // Contract
  dpa: faShieldHalved,           // DPA
  dbs: faUserShield,             // DBS
  ico: faCertificate,            // ICO
  ppi: faShieldHalved,           // Private practice insurance
};

const initialState = DOCS.reduce((acc, d) => {
  acc[d.key] = { file: null, startDate: "", endDate: "" };
  return acc;
}, {});

const User = () => {
  const { id } = useParams()
  const axios = useAxiosPrivate()
  const [userData, setUserData] = useState({})
  const { setShowLoader, can, createInfo } = useAuth()
  const [userDocuments, setUserDocuments] = useState([]);
  const [cancelled, setCancelled] = useState({});

  // Services
  const [services, setServices] = useState([])
  const [assignService, setAssignService] = useState({})
  const [assignedServices, setAssignedServices] = useState([])
  const [deleteService, setDeleteService] = useState({})
  const [videoSessionAvailability, setVideoSessionAvailability] =
    useState(false)

  // Modal
  const [showModal, setShowModal] = useState(false)
  const [modalTitle, setModalTitle] = useState('')

  const getUserById = async () => {
    try {
      setShowLoader(true)
      const response = await axios.get(`/users/${id}`)
      setUserData(response.data.result)
      if (response.data.result.video_sessions == 1) {
        setVideoSessionAvailability(true)
      } else {
        setVideoSessionAvailability(false)
      }
      setAssignedServices(response.data.result.services)
      setShowLoader(false)
    } catch (error) { }
  }
  const handleUpdateUser = (updatedUser) => {
    setUserData(updatedUser)
  }

  const assignServiceClicked = () => {
    getServices()
    setAssignService({})
    setModalTitle(`Assign Service`)
    setShowModal(true)
  }

  const deleteServiceClicked = (service) => {
    setModalTitle('Unassign Service: ' + service.title)
    setDeleteService({ ...service })
    setShowModal(true)
  }

  const getServices = async () => {
    try {
      setShowLoader(true)
      const response = await axios.get(`/services/by-user/${id}`)
      if (response.data.result) {
        setServices(response.data.result)
      }
    } catch (error) { }
    setShowLoader(false)
  }

  const resetModal = () => {
    setAssignService({})
    setDeleteService({})
    setShowModal(false)
  }

  const ModalBody = () => {
    if (deleteService.id) {
      return <DeleteServiceElement />
    }

    if (assignService) {
      return <AssignServiceElement />
    }
  }

  //file upload
  //drag and drop
  const [showFiles, setShowFiles] = useState([])
  const [values, setValues] = useState(initialState);
  const [errors, setErrors] = useState({});

  const handleFileChange = (key, file) => {
    setValues((prev) => ({ ...prev, [key]: { ...prev[key], file } }))
    setErrors((e) => ({ ...e, [key]: undefined }))
  }

  const handleDateChange = (key, field, val) => {
    setValues((prev) => {
      const updated = { ...prev, [key]: { ...prev[key], [field]: val } }

      const doc = updated[key];
      if (doc.file || getUploadedDocByLabel(DOCS.find(d => d.key === key).label)) {
        clearTimeout(doc._timeout);
        doc._timeout = setTimeout(() => {
          uploadDocument(key, doc.file, doc.startDate, doc.endDate);
        }, 500)
      }
  
      return updated;
    })
    setErrors((e) => ({ ...e, [key]: undefined }))
  }

  const isExpiringOrExpired = (expiryDate) => {
    if (!expiryDate) return true
    const expiry = new Date(expiryDate)
    const now = new Date()
    const in30Days = new Date()
    in30Days.setDate(now.getDate() + 30)
    return expiry <= in30Days
  }

  const fetchDocuments = async (id) => {
    try {
      setShowLoader(true)
      const response = await axios.get(`/user/documents/${id}`)
  
      const updated = { ...initialState }
      response.data.result.forEach(doc => {
        const match = DOCS.find(d => d.label.toLowerCase() === doc.name.toLowerCase())
        if (match) {
          updated[match.key] = {
            file: null,
            startDate: doc.start_date || "",
            endDate: doc.expiry_date || ""
          }
        }
      })
  
      setValues(updated);
      setUserDocuments(response.data.result)
    } catch (error) {
      console.error("Failed to fetch documents", error)
    } finally {
      setShowLoader(false)
    }
  }  

  const getUploadedDocByLabel = (label) =>
  userDocuments.find((doc) => doc.name === label)

  const fmtMonthYear = (d) =>
  d ? new Date(d).toLocaleDateString('en-GB', { month: 'short', year: 'numeric' }) : ''

  // progress
  const uploadedCount = DOCS.filter(d => getUploadedDocByLabel(d.label)).length
  const progressPct = Math.round((uploadedCount / DOCS.length) * 100)

  const AssignServiceElement = () => {
    const assignServiceSubmit = async (e) => {
      e.preventDefault()
      setShowLoader(true)
      const data = JSON.parse(assignService)

      try {
        const response = await axios.post(`/users/assign-service`, {
          userId: userData.id,
          serviceId: data.id,
        })
        createInfo('success', `Assigned Service: ${data.title}`)
        setUserData(response.data.result)
        setAssignedServices(response.data.result.services)
        resetModal(false)
      } catch (error) {
        console.error(error)
      }

      setShowLoader(false)
    }

    return (
      <form onSubmit={assignServiceSubmit}>
        <div className="mb-3">
          <label
            htmlFor="name"
            className="block font-medium text-gray-600 text-sm"
          >
            Service Name
          </label>
          <select
            defaultValue={assignService}
            className="px-2 py-2 block w-full border border-gray-300 rounded-md shadow-md"
            required
            onChange={(e) => setAssignService(e.target.value)}
          >
            <option disabled value={{}}>
              Select Service
            </option>
            {services?.map((service) => {
              if (
                !assignedServices.find((assignedService) => {
                  return service.id === assignedService.id
                })
              ) {
                return (
                  <option key={service.id} value={JSON.stringify(service)}>
                    {service.title}
                  </option>
                )
              }
            })}
          </select>
        </div>
        <div className="flex mt-2 w-full">
          <button className="btn mt-4 mr-4 w-1/2">Assign Service</button>
          <button
            type="button"
            className="btn red mt-4 w-1/2"
            onClick={resetModal}
          >
            Cancel
          </button>
        </div>
      </form>
    )
  }

  const DeleteServiceElement = () => {
    const removeService = async () => {
      setShowLoader(true)
      try {
        const response = await axios.post(`/users/unassign-service`, {
          userId: userData.id,
          serviceId: deleteService.id,
        })
        createInfo('error', `Unassigned Service: ${deleteService.title}`)
        setUserData(response.data.result)
        setAssignedServices(response.data.result.services)
        resetModal(false)
      } catch (error) { }
      setShowLoader(false)
    }
    return (
      <form onSubmit={removeService} className="justify-center flex">
        <div className="mb-3">
          <p className="text-lg font-bold my-8 text-center">
            Are you sure you want to unassign this service?
          </p>
          <div className="flex mt-2 w-full">
            <button className="btn red mt-4 mr-4 w-1/2">
              Unassign Service
            </button>

            <button
              type="button"
              className="btn mt-4 w-1/2"
              onClick={resetModal}
            >
              Cancel
            </button>
          </div>
        </div>
      </form>
    )
  }

  useEffect(() => {
    setUserData({})
    setUserDocuments([])
    if (id) {
      getUserById(id)
      fetchDocuments(id)
    }
  }, [id])

  const updateVideoAvailability = (e) => {
    let availability
    if (e) {
      availability = 1
    } else {
      availability = 0
    }
    setVideoSessionAvailability(e)
    axios
      .post(`/users/video-session-update`, {
        userId: userData.id,
        available: availability,
      })
      .then((response) => {
        createInfo('success', 'Updated Video Session Availability')
      })
      .catch((response) => {
        createInfo(
          'error',
          'There was an issue updating your Video Session Availability'
        )
      })
  }

  
  const submitForReview = async () => {
    try {
      setShowLoader(true)
      await axios.post(`/user/documents/${id}/submit-for-review`)
      createInfo('success', 'Submitted for review')
    } catch (e) {
      createInfo('error', 'Could not submit for review')
    } finally {
      setShowLoader(false)
    }
  }

  const hasAllDocs = DOCS.every(d => getUploadedDocByLabel(d.label))

  const deleteDocument = async (docId, label) => {
    try {
      await axios.post(`/user/document-delete/${docId}`)
      createInfo("success", `${label} deleted`);
      setUserDocuments(prev => prev.filter(doc => doc.id !== docId))
    } catch (err) {
      createInfo("error", "Delete failed")
    }
  };
  
  const handleUpdateDocDates = async (docId, key, field, value) => {
    setValues(prev => ({
      ...prev,
      [key]: { ...prev[key], [field]: value }
    }))
  
    const startDate = field === "startDate" ? value : values[key]?.startDate
    const endDate = field === "endDate" ? value : values[key]?.endDate

    if (startDate && endDate && new Date(startDate) > new Date(endDate)) {
      createInfo("error", "End date must be after the start date")
      return
    }
  
    try {
      await axios.post(`/user/document-update-dates/${docId}`, {
        field,
        value,
      })
      createInfo("success", "Date updated")
      fetchDocuments(id)
    } catch (err) {
      createInfo("error", "Update failed")
    }

    setCancelled(prev => ({ ...prev, [key]: false }));
  }
  

  const uploadDocument = async (key, file, startDate, endDate) => {
    const formData = new FormData();
    formData.append(key, file);
    formData.append(`document_name_${key}`, DOCS.find(d => d.key === key).label);
    if (startDate) formData.append(`${key}_start`, startDate);
    if (endDate) formData.append(`${key}_end`, endDate);
  
    try {
      await axios.post(`/user/document-upload/${id}`, formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });
      createInfo("success", `${DOCS.find(d => d.key === key).label} uploaded`);
      fetchDocuments(id);
    } catch (err) {
      createInfo("error", "Upload failed");
    }

    setCancelled(prev => ({ ...prev, [key]: false }));
  }

  return (
    <div>
      {showModal && (
        <Modal title={modalTitle} body={<ModalBody />} show={resetModal} />
      )}

      <MainTitle title="Profile" />
      <UserNav active="profile" userId={userData.id} />
      <UserProfile user={userData} onUpdateUser={handleUpdateUser} />

      <section className="w-full bg-white rounded-xl shadow-md py-4 px-4 mb-8">
        <div className="flex mb-4">
          <p className="mr-4">Available for Video Sessions:</p>
          <Switch
            checked={videoSessionAvailability}
            onChange={updateVideoAvailability}
            className="group relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-200 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 data-[checked]:bg-indigo-600"
          >
            <span className="sr-only">Available for Video Sessions</span>
            <span className="pointer-events-none relative inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5">
              <span
                aria-hidden="true"
                className="absolute inset-0 flex h-full w-full items-center justify-center transition-opacity duration-200 ease-in group-data-[checked]:opacity-0 group-data-[checked]:duration-100 group-data-[checked]:ease-out"
              >
                <svg
                  fill="none"
                  viewBox="0 0 12 12"
                  className="h-3 w-3 text-gray-400"
                >
                  <path
                    d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
              <span
                aria-hidden="true"
                className="absolute inset-0 flex h-full w-full items-center justify-center opacity-0 transition-opacity duration-100 ease-out group-data-[checked]:opacity-100 group-data-[checked]:duration-200 group-data-[checked]:ease-in"
              >
                <svg
                  fill="currentColor"
                  viewBox="0 0 12 12"
                  className="h-3 w-3 text-indigo-600"
                >
                  <path d="M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z" />
                </svg>
              </span>
            </span>
          </Switch>
        </div>
        <div className="flex items-center mb-4 w-full justify-between">
          <h2 className="font-bold text-lg">Services</h2>
          {can(`assign services`) && userData.status_id !== 3 && (
            <div
              className="cursor-pointer ml-4 text-blue-500 font-bold items-center flex btn"
              onClick={assignServiceClicked}
            >
              <span>Assign Service</span>
            </div>
          )}
        </div>

        <ul className="flex">
          {assignedServices?.map((service) => {
            return (
              <li key={service.id} className="flex">
                <span className="pill">{service.title}</span>
                {can('remove user services') ? (
                  <span
                    title="Remove Service"
                    className="pill-button"
                    onClick={() => deleteServiceClicked(service)}
                  >
                    <FontAwesomeIcon icon={faTrash} />
                  </span>
                ) : (
                  <span className="mr-4"></span>
                )}
              </li>
            )
          })}
        </ul>
      </section>
      {/* Document Upload */}
      <section className="w-full bg-white rounded-2xl shadow-md py-6 px-6">
        <div className="flex items-center justify-between mb-4">
          <h2 className="font-bold text-xl">Legal Documents</h2>
        </div>

        {/* If documents exist, list them */}
        {showFiles.length > 0 ? (
          <div className="space-y-4">
            {DOCS.map((doc) => {
              const uploadedDoc = showFiles.find(f => f.name?.toLowerCase() === doc.label.toLowerCase())
              const expired = isExpiringOrExpired(uploadedDoc?.expiry_date)

              return (
                <div key={doc.key} className="flex items-center justify-between border rounded-xl px-4 py-3 shadow-sm">
                  <div className="flex items-center gap-3">
                    <FontAwesomeIcon icon={faFile} className="text-blue-600" />
                    <div>
                      <div className="font-semibold">{doc.label}</div>
                      {uploadedDoc ? (
                        <div className="text-sm text-gray-600">
                          Uploaded: {uploadedDoc.created_at?.slice(0, 10)}{" "}
                          {uploadedDoc.expiry_date && ` | Expires: ${uploadedDoc.expiry_date}`}
                        </div>
                      ) : (
                        <div className="text-sm text-red-600">Missing</div>
                      )}
                    </div>
                  </div>

                  {expired && (
                    <button
                      className="text-sm bg-blue-600 text-white px-3 py-1 rounded hover:bg-blue-700"
                      onClick={() => setValues(prev => ({
                        ...prev,
                        [doc.key]: { file: null, startDate: "", endDate: "" }
                      }))}
                    >
                      Upload New
                    </button>
                  )}
                </div>
              )
            })}
          </div>
        ) : (
          <>
            <div className="text-sm text-gray-600 mb-2">
              Please upload each document. <strong>BACP, ICO</strong> and <strong>Private Practice Insurance</strong> require an end date. These are required to stay compliant.
            </div>
            <div className="mt-4 h-2 w-2/4 rounded-full bg-gray-100">
              <div
                className="h-2 rounded-full bg-blue-500 transition-all"
                style={{ width: `${progressPct}%` }}
              />
            </div>
            <p className="mt-2 text-sm text-gray-600">{uploadedCount}/{DOCS.length} documents uploaded</p>

            <div className="mt-6">
              <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5">
                {DOCS.map((d) => {
                  const uploaded = getUploadedDocByLabel(d.label)
                  const staged = values[d.key]?.file

                  let expiryBadge = null;
                  if (uploaded?.expiry_date) {
                    const expDate = new Date(uploaded.expiry_date);
                    const now = new Date();
                    const diffDays = (expDate - now) / (1000 * 60 * 60 * 24);

                    if (diffDays < 0) {
                      expiryBadge = <span className="ml-2 text-red-600 font-semibold">(Expired)</span>;
                    } else if (diffDays <= 30) {
                      expiryBadge = <span className="ml-2 text-amber-600 font-semibold">(Expiring soon)</span>;
                    }
                  }

                  return (
                    <div key={d.key} className="rounded-2xl border border-gray-200 bg-white p-5 shadow-sm">
                      {/* Title row */}
                      <div className="flex items-center justify-between">
                        <div className="flex items-center gap-3">
                          {uploaded && !staged ? (
                            <FontAwesomeIcon icon={faCircleCheck} className="text-green-600 h-6 w-6" />
                          ) : (
                            <FontAwesomeIcon
                              icon={ICONS[d.key] || faFile}
                              className="text-blue-600 h-6 w-6"
                            />
                          )}
                          <span className="font-semibold text-gray-800">{d.label}</span>
                        </div>
                        {(uploaded && !staged && can('edit documents')) && (
                          <div className="flex space-x-3 text-xs">
                            <button
                              type="button"
                              onClick={() =>
                                setUserDocuments(prev =>
                                  prev.map(doc => (
                                    doc.id === uploaded.id ? { ...doc, isEditing: true } : doc
                                  ))
                                )
                              }
                              className="text-blue-600 hover:text-blue-800"
                            >
                              <FontAwesomeIcon icon={faPenToSquare} className="mr-1" />
                              Edit
                            </button>

                            <button
                              type="button"
                              onClick={() => deleteDocument(uploaded.id, d.label)}
                              className="text-red-600 hover:text-red-800"
                            >
                              <FontAwesomeIcon icon={faTrash} className="mr-1" />
                              Delete
                            </button>
                          </div>
                        )}
                        <>
                          {cancelled[d.key] && (
                            <button
                              type="button"
                              onClick={() => {
                                setCancelled(prev => ({ ...prev, [d.key]: false }));
                                fetchDocuments(id);
                              }}
                              className="text-red-600 hover:text-red-800 text-xs ml-3"
                            >
                              <FontAwesomeIcon icon={faXmarkCircle} className="mr-1" />
                              Cancel
                            </button>
                          )}
                        </>
                      </div>

                      {/* Already uploaded */}
                      {uploaded && !staged && (
                        <div className="mt-3 text-sm text-gray-600 space-y-2">
                          <a
                            href={uploaded.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center text-blue-600 hover:underline"
                          >
                            <FontAwesomeIcon icon={faEye} className="mr-2" />
                            View Document
                          </a>
                          <p>
                            <strong>Uploaded:</strong>{" "}
                            {new Date(uploaded.created_at).toLocaleDateString()}
                          </p>

                          {uploaded.isEditing ? (
                            <div className="flex items-center space-x-2">
                              <input
                                type="date"
                                value={values[d.key].startDate || uploaded.start_date || ""}
                                onChange={(e) =>
                                  handleUpdateDocDates(uploaded.id, d.key, "startDate", e.target.value)
                                }
                                className="rounded border px-2 py-1 text-sm"
                              />
                              <input
                                type="date"
                                value={values[d.key].endDate || uploaded.expiry_date || ""}
                                onChange={(e) =>
                                  handleUpdateDocDates(uploaded.id, d.key, "endDate", e.target.value)
                                }
                                className="rounded border px-2 py-1 text-sm"
                              />
                              <button
                                type="button"
                                onClick={() =>
                                  setUserDocuments(prev =>
                                    prev.map(doc =>
                                      doc.id === uploaded.id ? { ...doc, isEditing: false } : doc
                                    )
                                  )
                                }
                                className="text-sm text-green-600 hover:underline"
                              >
                                Done
                              </button>
                            </div>
                          ) : (
                            <div className="flex items-center space-x-2">
                              {uploaded.start_date && (
                                <p>
                                  <strong>Start:</strong>{" "}
                                  {new Date(uploaded.start_date).toLocaleDateString()}
                                </p>
                              )}
                              {uploaded.expiry_date && (
                                <p>
                                  <strong>Expiry:</strong>{" "}
                                  {new Date(uploaded.expiry_date).toLocaleDateString()} {expiryBadge}
                                </p>
                              )}
                            </div>
                          )}
                          <button
                            type="button"
                            onClick={() => {
                              setCancelled(prev => ({ ...prev, [d.key]: true }))
                              setValues(prev => ({
                                ...prev,
                                [d.key]: { file: null, startDate: "", endDate: "" }
                              }));
                              setUserDocuments(prev =>
                                prev.filter(doc => doc.name.toLowerCase() !== d.label.toLowerCase())
                              );
                            }}
                            className="mt-3 inline-flex items-center rounded-lg bg-blue-600 px-3 py-2 text-sm font-medium text-white hover:bg-blue-700"
                          >
                            <FontAwesomeIcon icon={faUpload} className="mr-2" />
                            Upload New Document
                          </button>
                        </div>
                      )}
                      <input
                        id={`file-${d.key}`}
                        type="file"
                        className="hidden"
                        onChange={(e) => {
                          if (e.target.files?.[0]) {
                            const file = e.target.files[0];
                            handleFileChange(d.key, file);

                            // if no end date required OR already set, upload immediately
                            if (!d.requiresEndDate || values[d.key].endDate) {
                              uploadDocument(d.key, file, values[d.key].startDate, values[d.key].endDate);
                            }
                          }
                        }}
                      />

                      {/* Not uploaded yet (empty slot) */}
                      {!uploaded && !staged && (
                        <div className="mt-4 space-y-3">
                        {/* Dates visible even before file is chosen */}
                        <div className='flex items-center justify-between'>
                          <div>
                            <label className="text-xs text-gray-600">Start Date</label>
                            <input
                              type="date"
                              value={values[d.key].startDate}
                              onChange={(e) => handleDateChange(d.key, "startDate", e.target.value)}
                              className="mt-1 w-full rounded-lg border px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-blue-500"
                            />
                          </div>

                          <div>
                            <label className="text-xs text-gray-600">
                              End Date {d.requiresEndDate && <span className="text-red-600">*</span>}
                            </label>
                            <input
                              type="date"
                              value={values[d.key].endDate}
                              onChange={(e) => handleDateChange(d.key, "endDate", e.target.value)}
                              className="mt-1 w-full rounded-lg border px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-blue-500"
                            />
                          </div>
                        </div>
                        <button
                          type="button"
                          id={`upload-btn-${d.key}`}
                          onClick={() => document.getElementById(`file-${d.key}`).click()}
                          disabled={d.requiresEndDate && !values[d.key].endDate}
                          data-tooltip-content={d.requiresEndDate && !values[d.key].endDate 
                            ? "Please select an end date before uploading a document" 
                            : ""}
                          className="inline-flex w-full items-center justify-center rounded-lg border border-gray-300 px-3 py-2 text-sm 
                                    font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                          <FontAwesomeIcon icon={faUpload} className="mr-2" />
                          Upload Document
                        </button>

                        <Tooltip anchorSelect={`#upload-btn-${d.key}`} place="top" />
                        </div>
                      )}

                      {/* Staged new file */}
                      {staged && (
                        <div className="mt-4 space-y-3">
                          <div className='flex items-center justify-between'>
                            <div>
                              <label className="text-xs text-gray-600">Start Date</label>
                              <input
                                type="date"
                                value={values[d.key].startDate}
                                onChange={(e) => handleDateChange(d.key, "startDate", e.target.value)}
                                className="mt-1 w-full rounded-lg border px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-blue-500"
                              />
                            </div>
                            <div>
                              <label className="text-xs text-gray-600">
                                End Date {d.requiresEndDate && <span className="text-red-600">*</span>}
                              </label>
                              <input
                                type="date"
                                value={values[d.key].endDate}
                                onChange={(e) => handleDateChange(d.key, "endDate", e.target.value)}
                                className="mt-1 w-full rounded-lg border px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-blue-500"
                              />
                            </div>
                          </div>
                          <div className="flex items-center justify-between">
                            <p className="text-sm text-gray-700">Selected: {staged.name}</p>
                            <button
                              type="button"
                              onClick={() => handleFileChange(d.key, null)}
                              className="text-gray-500 hover:text-red-600 text-sm"
                              aria-label={`Remove ${d.label} file`}
                            >
                              <FontAwesomeIcon icon={faTrashCan} />
                            </button>
                          </div>
                          
                          {errors[d.key] && (
                            <p className="text-xs text-red-600">{errors[d.key]}</p>
                          )}
                        </div>
                      )}
                    </div>
                  )
                })}
              </div>

              {/* Footer buttons */}
              <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4">
                <button
                  type="button"
                  onClick={submitForReview}
                  disabled={!hasAllDocs}
                  className="inline-flex items-center justify-center rounded-xl px-4 py-3 text-sm font-semibold shadow-sm 
                            bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Submit for Review
                </button>
              </div>
            </div>
          </>
        )}
      </section>
    </div>
  )
}

export default User

